export default "__VITE_ASSET__B$N1NU_Q__"